<template>
  <BaseViewComponent
    name="media"
    :is-preview="isPreview"
  >
    <div class="container media-wrapper">
      <div
        v-if="isMediaVideo && mediaContent"
        class="iframe-wrapper"
      >
        <iframe
          :src="mediaContent"
          class="video border-radius-20"
        />
      </div>
      <img
        v-else
        class="image border-radius-20"
        :src="mediaContent ? getCompressImage(mediaContent) : '/landing/media-placeholder.png'"
      >
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import getCompressImage from 'src/helpers/getCompressImage';

const props = defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const {
  mediaContent,
  isMediaVideo,
} = useBookPageEdit(props.data);

</script>
